import { createContainer, asFunction } from 'awilix';

import { FileStorageModuleClientType, FileStorageModuleServerType } from './lib/file-storage';

type ServerModules = {
  fileStorage: FileStorageModuleServerType;
};
type ClientModules = {
  fileStorage: FileStorageModuleClientType;
};

type ServerModuleCreatorFunction<T = unknown> = (serverModules: ServerModules) => T;
type ClientModuleCreatorFunction<T = unknown> = (clientModules: ClientModules) => T;

type ServerModulesCreators = {
  fileStorage: ServerModuleCreatorFunction<FileStorageModuleServerType>;
};
type ClientModulesCreators = {
  fileStorage: ClientModuleCreatorFunction<FileStorageModuleClientType>;
};

const clientModulesContainer = createContainer<ClientModules>({
  strict: true,
  injectionMode: 'PROXY'
});
const clientModules = clientModulesContainer.cradle;
const serverModulesContainer = createContainer<ServerModules>({
  strict: true,
  injectionMode: 'PROXY'
});
const serverModules = serverModulesContainer.cradle;

function createServerModules(serverModulesCreators: ServerModulesCreators) {
  serverModulesContainer.register({
    fileStorage: asFunction(serverModulesCreators.fileStorage).singleton()
  });

  return serverModulesContainer;
}

function createClientModules(clientModulesCreators: ClientModulesCreators) {
  clientModulesContainer.register({
    fileStorage: asFunction(clientModulesCreators.fileStorage).singleton()
  });

  return clientModulesContainer;
}

export { clientModules, serverModules, createClientModules, createServerModules };
export type { ClientModulesCreators, ServerModulesCreators };
